import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  DateField,
  ListContextProvider,
  NumberField,
  ReferenceField,
  TextField,
  useGetList,
  useListContext,
  ListBase,
  ListToolbar,
  Pagination,
  ShowButton,
} from 'react-admin';

import { Divider, Tabs, Tab, Card } from '@material-ui/core';

import ChangeAtivoButton from '../../Components/ChangeAtivoButton';
import Datagrid from '../../Components/Datagrid';
import DialogoAtivarResources from '../../Components/DialogoAtivarResource';
import DialogoDeleteResource from '../../Components/DialogoDeleteResource';
import EditButton from '../../Components/EditButton2';
import Actions from './ActionsList';
import Dialogo from './ContainerDialogoDevolucao';
import Filter from './Filter';

const tabs = [
  { id: 'confirmado', name: 'confirmado' },
  { id: 'cancelado', name: 'cancelado' },
];

const useGetTotals = (filterValues) => {
  const { total: totalConfirmado } = useGetList(
    'commands',
    { perPage: 1, page: 1 },
    { field: 'id', order: 'ASC' },
    { ...filterValues, cancelado: false },
  );
  const { total: totalCancelado } = useGetList(
    'commands',
    { perPage: 1, page: 1 },
    { field: 'id', order: 'ASC' },
    { ...filterValues, cancelado: true },
  );

  return {
    confirmado: totalConfirmado,
    cancelado: totalCancelado,
  };
};

const MyList = ({ ...props }) => {
  const refDialogoCompra = useRef(null);
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [confirmados, setConfirmados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  const totals = useGetTotals(filterValues);
  const refDialogoDeleteResource = useRef(null);
  const refDialogoAtivaResource = useRef(null);

  function ativarHandle(record) {
    if (refDialogoAtivaResource.current)
      refDialogoAtivaResource.current.handleOpen(record);
  }

  useEffect(() => {
    if (ids && ids !== filterValues.cancelado) {
      switch (filterValues.cancelado) {
        case false:
          setConfirmados(ids);
          break;
        case true:
          setCancelados(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.cancelado]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          { ...filterValues, cancelado: value === 'cancelado' },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );
  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }
  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<Actions handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.cancelado ? tabs[1].id : tabs[0].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab
              key={choice.id}
              label={
                totals[choice.name]
                  ? `${choice.name} (${totals[choice.name]})`
                  : choice.name
              }
              value={choice.id}
            />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.cancelado === false && (
            <ListContextProvider value={{ ...listContext, ids: confirmados }}>
              <Datagrid {...props}>
                <TextField source="numero" label="Nº venda" />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                >
                  <TextField source="nome" />
                </ReferenceField>
                <NumberField
                  source="valor"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor Total"
                />
                <NumberField
                  source="valorEmDinheiro"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor em dinheiro"
                  sortable={false}
                />
                <DateField source="data" label="Data da Venda" />
                <EditButton editHundle={handleEdit} />
                <ShowButton />
                <ChangeAtivoButton
                  deleteHundle={ativarHandle}
                  campoAtivo="cancelado"
                  inverterAtivo
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.cancelado === true && (
            <ListContextProvider value={{ ...listContext, ids: cancelados }}>
              <Datagrid {...props}>
                <TextField source="numero" label="Nº venda" />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                >
                  <TextField source="nome" />
                </ReferenceField>
                <NumberField
                  source="valor"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor Total"
                />
                <NumberField
                  source="valorEmDinheiro"
                  locales="pt-BR"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: 'currency',
                    currency: 'BRL',
                  }}
                  label="Valor em dinheiro"
                  sortable={false}
                />
                <DateField source="data" label="Data da Venda" />
                <EditButton editHundle={handleEdit} />
                <ShowButton />
                <ChangeAtivoButton
                  deleteHundle={ativarHandle}
                  campoAtivo="cancelado"
                  inverterAtivo
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
      <DialogoAtivarResources
        ref={refDialogoAtivaResource}
        campoAtivo="cancelado"
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]} {...props} />
);

const List2 = (props) => (
  <>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Compras"
      filterDefaultValues={{
        periodo: {
          start: new Date(),
          end: new Date(),
        },
        cancelado: false,
      }}
      filter={{ devolucao: true }}
    />
  </>
);

export default List2;
